import { Subscription } from '../../../models';
import { SubscriptionBox } from './SubscriptionBox';

export const SubscriptionFlexView = (
  { groupId, color, subscriptions }: {
    groupId: string,
    color: string,
    subscriptions: Subscription[],
  },
) => (
  <>
    {subscriptions.map(subscription => (
      <SubscriptionBox
        key={subscription.id}
        groupId={groupId}
        color={color}
        subscription={subscription}
      />
    ))}
  </>
);
